// samplingEventsList/actions.js

import { getSamplingEvents } from "../../api/SamplingEventsApi";
import { samplingEventsListInitialState } from "./samplingEventListsState";

export const makeSamplingEventsListActions = (set, get) => ({
  setActiveListPage: (page) =>
    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        active: {
          ...s.samplingEventsList.active,
          pagination: {
            ...s.samplingEventsList.active.pagination,
            currentPage: page,
          },
        },
      },
    })),

  setActiveEventsPerPage: (perPage) =>
    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        active: {
          ...s.samplingEventsList.active,
          pagination: {
            ...s.samplingEventsList.active.pagination,
            eventsPerPage: perPage,
            currentPage: 1,
          },
        },
      },
    })),

  setSelectedActiveSamplingEvent: (event) =>
    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        active: {
          ...s.samplingEventsList.active,
          selectedId: event?.id || null,
        },
      },
    })),

  fetchActiveSamplingEventsPage: async () => {
    const {
      samplingEventsList: {
        active: {
          pagination: { currentPage, eventsPerPage },
        },
      },
    } = get();

    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        active: {
          ...s.samplingEventsList.active,
          isLoading: true,
          error: null,
        },
      },
    }));

    try {
      const response = await getSamplingEvents(
        "active",
        currentPage,
        eventsPerPage
      );
      // axios response expected
      const { sampling_events, pagination } = response.data || {};
      set((s) => ({
        samplingEventsList: {
          ...s.samplingEventsList,
          active: {
            ...s.samplingEventsList.active,
            isLoading: false,
            items: sampling_events || [],
            pagination: pagination
              ? {
                  currentPage: pagination.page,
                  totalPages: pagination.pages,
                  totalEvents: pagination.total,
                  eventsPerPage: pagination.per_page,
                }
              : s.samplingEventsList.active.pagination,
          },
        },
      }));
      return { ok: true };
    } catch (err) {
      console.error("Failed to fetch sampling events page:", err);
      set((s) => ({
        samplingEventsList: {
          ...s.samplingEventsList,
          active: {
            ...s.samplingEventsList.active,
            isLoading: false,
            error: err?.message || "Failed to load events",
          },
        },
      }));
      return { ok: false, error: err };
    }
  },

  setCompletedListPage: (page) =>
    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        completed: {
          ...s.samplingEventsList.completed,
          pagination: {
            ...s.samplingEventsList.completed.pagination,
            currentPage: page,
          },
        },
      },
    })),

  setCompletedEventsPerPage: (perPage) =>
    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        completed: {
          ...s.samplingEventsList.completed,
          pagination: {
            ...s.samplingEventsList.completed.pagination,
            eventsPerPage: perPage,
            currentPage: 1,
          },
        },
      },
    })),

  setSelectedCompletedSamplingEvent: (event) =>
    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        completed: {
          ...s.samplingEventsList.completed,
          selectedId: event?.id || null,
        },
      },
    })),

  fetchCompletedSamplingEventsPage: async () => {
    const {
      samplingEventsList: {
        completed: {
          pagination: { currentPage, eventsPerPage },
        },
      },
    } = get();

    set((s) => ({
      samplingEventsList: {
        ...s.samplingEventsList,
        completed: {
          ...s.samplingEventsList.completed,
          isLoading: true,
          error: null,
        },
      },
    }));

    try {
      const response = await getSamplingEvents(
        "completed",
        currentPage,
        eventsPerPage
      );
      const { sampling_events, pagination } = response.data || {};
      set((s) => ({
        samplingEventsList: {
          ...s.samplingEventsList,
          completed: {
            ...s.samplingEventsList.completed,
            isLoading: false,
            items: sampling_events || [],
            pagination: pagination
              ? {
                  currentPage: pagination.page,
                  totalPages: pagination.pages,
                  totalEvents: pagination.total,
                  eventsPerPage: pagination.per_page,
                }
              : s.samplingEventsList.completed.pagination,
          },
        },
      }));
      return { ok: true };
    } catch (err) {
      console.error("Failed to fetch completed sampling events page:", err);
      set((s) => ({
        samplingEventsList: {
          ...s.samplingEventsList,
          completed: {
            ...s.samplingEventsList.completed,
            isLoading: false,
            error: err?.message || "Failed to load events",
          },
        },
      }));
      return { ok: false, error: err };
    }
  },

  resetSamplingEventsList: () =>
    set({ samplingEventsList: samplingEventsListInitialState }),
});
